import { ReducersRegistry } from "@grandvisionhq/state";
import shippingReducer from "./state/state/reducer.js";
import * as index from "./operations/operations/index.js";
import { defaultDeliveryResolver } from "./utils/utils/default-delivery-resolver.js";
import { DeliveryIndicatorLoader } from "./modules/DeliveryIndicator/components/modules/DeliveryIndicator/components/DeliveryIndicatorLoader.js";
import { DeliveryIndicator } from "./modules/DeliveryIndicator/components/modules/DeliveryIndicator/components/DeliveryIndicator.js";
import { DynamicDeliveryIndicator } from "./modules/DeliveryIndicator/containers/modules/DeliveryIndicator/containers/DynamicDeliveryIndicator.js";
import { DeliveryIndicator as DeliveryIndicator2 } from "./modules/DeliveryIndicator/layout/modules/DeliveryIndicator/layout/DeliveryIndicator.js";
import { useGetDeliveryEstimationMessage } from "./hooks/hooks/use-get-delivery-estimation-message.js";
import { useGetDispatchDate } from "./hooks/hooks/use-get-dispatch-date.js";
import { useGetShippingMethods } from "./hooks/hooks/use-get-shipping-methods.js";
import { useDeliveryIndicator, withDeliveryIndicator } from "./contexts/DeliveryIndicator/contexts/DeliveryIndicator/context.js";
import { DeliveryIndicatorProvider } from "./contexts/DeliveryIndicator/contexts/DeliveryIndicator/provider.js";
import { setPreferredShippingMethod } from "./state/state/actions.js";
import { getPreferredShippingMethod } from "./state/state/selectors.js";
ReducersRegistry.register("shipping", shippingReducer);
export {
  DeliveryIndicator2 as DeliveryIndicator,
  DeliveryIndicator as DeliveryIndicatorComponent,
  DeliveryIndicatorLoader,
  DeliveryIndicatorProvider,
  DynamicDeliveryIndicator,
  index as Operations,
  defaultDeliveryResolver,
  getPreferredShippingMethod,
  setPreferredShippingMethod,
  useDeliveryIndicator,
  useGetDeliveryEstimationMessage,
  useGetDispatchDate,
  useGetShippingMethods,
  withDeliveryIndicator
};
//# sourceMappingURL=index.js.map
